import React from 'react';
import IconComponent from 'ui/src/components/Icon';
import extractText from 'utilities/src/extractText';
import twMerge from 'utilities/src/twMerge';
import PreviewPostError from './PreviewPostError';
import { type SlugPageProps } from './SlugPage';

type HeroPostProps = {
  preview: boolean;
  errors: string | null;
  post: SlugPageProps['post'];
  className?: string;
};

export default function HeroPost({ preview, errors, post, className }: HeroPostProps) {
  return (
    <div className={twMerge('md:w-[40.125rem] lg:w-auto 2xl:w-[62rem]', className)}>
      {preview && errors && <PreviewPostError message={errors} />}
      <h1 className="site-display-l text-site-neutrals-900 font-medium">{post.title}</h1>
      <p className="text-site-neutrals-600 site-paragraph-xl my-6">{extractText(post.excerpt)}</p>

      <div className="site-overline-s text-site-neutrals-500 flex flex-col gap-2">
        <span className="flex items-center gap-3 uppercase hover:underline md:hidden">
          <IconComponent iconName="FolderCopy" className="bg-site-neutrals-200" />
          {post.categories?.nodes?.[0]?.name}
        </span>
        <span className="flex items-center gap-3 uppercase">
          <IconComponent iconName="Schedule" className="bg-site-neutrals-200" />
          {post?.timeToRead || 10} min read
        </span>
      </div>
    </div>
  );
}
